import * as yup from 'yup';
import Schema from '@/schema/Schema';
import trI18n from '@/common/utils/trI18n';

// Matches a string containing no whitespace characters (empty allowed)
const NO_WHITESPACE_REGEX = /^\S*$/;

// Message functions: translated at validation time, not frozen at module import
const requiredMessage = () => trI18n('MSG-CM-REQUIRED-INPUT');
const maxLengthMessage = maxLength => () => trI18n('COMMSG027').replace('{{maxLength}}', String(maxLength));

const McpCatalogFormSchema = Schema.object().shape({
    mcpName: yup
        .string()
        .required(requiredMessage)
        .max(128, maxLengthMessage(128))
        .trim(),

    mcpPackageName: yup
        .string()
        .required(requiredMessage)
        .max(128, maxLengthMessage(128))
        .matches(NO_WHITESPACE_REGEX, () => trI18n('MCP_ERR_PACKAGE_NAME_SPACE'))
        .trim(),

    mcpPackageVersion: yup
        .string()
        .max(128, maxLengthMessage(128))
        .matches(NO_WHITESPACE_REGEX, () => trI18n('MCP_ERR_PACKAGE_VERSION_SPACE'))
        .nullable(),

    mcpType: yup
        .string()
        .required(requiredMessage),

    requiredEnv: yup
        .string()
        .max(500, maxLengthMessage(500))
        .nullable(),

    description: yup
        .string()
        .max(500, maxLengthMessage(500))
        .nullable(),

    purpose: yup
        .string()
        .required(requiredMessage)
        .trim(),

    supportedOS: yup
        .array()
        .of(yup.string())
        .min(1, requiredMessage)
        .required(requiredMessage),

    downloadURL: yup
        .string()
        .required(requiredMessage)
        .url(() => trI18n('COMMSG015'))
        .trim(),

    prerequisites: yup
        .string()
        .nullable(),

    systemPrompt: yup
        .string()
        .nullable()
});

export default McpCatalogFormSchema;
